/**
 * @prop --stzh-pi-content-navigation-arrow-background-color: Background color of the arrow
 */


:host {
  --arrow-background-color: var(--stzh-pi-content-navigation-arrow-background-color, #{$colorSecondary30});

  display: flex;
  flex-direction: column;
}

.stzh-pi-content-navigation {
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: space('small');
  background-color: var(--stzh-color-coolgrey20);

  @include highContrast {
    border: 2px solid
  }

  &:hover &__arrow-icon {
    transform: translateX(4px);
  }

  &__wrapper {
    // @include spaceCurve('padding-left', 'intermediary');
    display: flex;
    // align-items: center;
    flex-grow: 1;
    @include spaceCurve('padding-right', 'intermediary');
    @include spaceCurve('padding-left', 'intermediary');
    @include spaceCurve('padding-top', 'regular');
    @include spaceCurve('padding-bottom', 'regular');
    flex-direction: column;
    align-items: flex-start;
  }

  &__image {
    width: 100%;
    display: none;
  }

  &__title {
    @include font('heavy');
    @include fontSize('deci', 'heading');
    @include wordWrap;
    color: var(--stzh-color-black);
    margin: 0;

    @include mq($from: medium) {
      @include fontSize('deca', 'heading');
    }

    &:has(+ .stzh-pi-content-navigation__lead) {
      @include spaceCurve('padding-bottom', 'small');
    }
  }

  &__title-link {
    display: block;
    font-family: inherit;
    padding: 0;
    appearance: none;
    background-color: transparent;
    border: none;
    color: var(--stzh-color-black);
    text-decoration-line: none;
    transition: color $baseTransitionAnimationSpeed;
    border-radius: $buttonBorderRadius;
    cursor: pointer;
    flex-grow: 1;
    padding-bottom: 40px; // safe space for arrow minus a optical correction


    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    &::after {
      z-index: 1;
    }
  }

  &__lead {
    @include fontCurve('p2');
  }

  &__arrow {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 44px;
    position: absolute;
    right: 0;
    bottom: 0;
    color: var(--stzh-color-black);
    background-color: var(--arrow-background-color);
  }

  &__arrow-icon {
    transition: transform 150ms ease;
    --size: #{iconSize('large')};
  }

  /* Level 3 and 4 */

  &:not(&--is-navigation-level-1-or-2) &__wrapper {
    @include spaceCurve('padding-right', 'small');
    @include spaceCurve('padding-left', 'small');
  }

  &:not(&--is-navigation-level-1-or-2) &__title-ratio &__title {
    @include spaceCurve('padding-right', 'small');
    @include spaceCurve('padding-left', 'small');
  }

  /* Has image */
  &--has-image &__image {
    display: block;
  }

  /* Title ratio styling (when navigation level 1 and 2 and no image) */
  &__title-ratio {
    background-color: var(--stzh-color-coolgrey30);
    aspect-ratio: 2/1;
    display: flex;
    align-items: center;
    @include spaceCurve('padding-top', 'regular');
    @include spaceCurve('padding-right', 'intermediary');
    @include spaceCurve('padding-bottom', 'regular');
    @include spaceCurve('padding-left', 'intermediary');
  }

  &__title-ratio &__title {
    // display: flex;
    // align-items: center;
    height: fit-content;
  }
}
